/**
 * @fileoverview POST handler for the "/engagement/email_templates/update_tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementEmailTemplatesUpdateTagsCacheKeys } from "./constants";
import type {
  PostEngagementEmailTemplatesUpdateTagsProps,
  EngagementEmailTemplatesUpdateTagsResult,
} from "./types";

export const postEngagementEmailTemplatesUpdateTags = reactQueryMutationAdapter(
  engagementEmailTemplatesUpdateTagsCacheKeys,
  (props: PostEngagementEmailTemplatesUpdateTagsProps): Promise<EngagementEmailTemplatesUpdateTagsResult> => {
    return fetch("/engagement/email_templates/update_tags", "POST", props);
  }
);
